import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}
interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: {
    value: string;
    label: string;
  }[];
}
export function Input({
  label,
  className = '',
  ...props
}: InputProps) {
  return <div className="mb-4" data-id="element-159">
      <label className="block text-sm font-medium text-gray-400 mb-1" data-id="element-160">
        {label}
      </label>
      <input className={`w-full bg-[#1a1a1a] border border-[#333] rounded-lg px-4 py-2 text-white focus:outline-none focus:border-[#0ea5e9] focus:ring-1 focus:ring-[#0ea5e9] transition-colors ${className}`} {...props} data-id="element-161" />
    </div>;
}
export function TextArea({
  label,
  className = '',
  ...props
}: TextAreaProps) {
  return <div className="mb-4" data-id="element-162">
      <label className="block text-sm font-medium text-gray-400 mb-1" data-id="element-163">
        {label}
      </label>
      <textarea className={`w-full bg-[#1a1a1a] border border-[#333] rounded-lg px-4 py-2 text-white focus:outline-none focus:border-[#0ea5e9] focus:ring-1 focus:ring-[#0ea5e9] transition-colors min-h-[120px] resize-y ${className}`} {...props} data-id="element-164" />
    </div>;
}
export function Select({
  label,
  options,
  className = '',
  ...props
}: SelectProps) {
  return <div className="mb-4" data-id="element-165">
      <label className="block text-sm font-medium text-gray-400 mb-1" data-id="element-166">
        {label}
      </label>
      <select className={`w-full bg-[#1a1a1a] border border-[#333] rounded-lg px-4 py-2 text-white focus:outline-none focus:border-[#0ea5e9] focus:ring-1 focus:ring-[#0ea5e9] transition-colors appearance-none cursor-pointer ${className}`} {...props} data-id="element-167">
        {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-168">
            {opt.label}
          </option>)}
      </select>
    </div>;
}